

export class TrackingModule {
    constructor() {
        this.init();
    }

    gaTrackEvent(category, action, opt_label, opt_value, opt_noninteraction) {
        if (opt_label === null) opt_label = undefined;
        if (opt_value === null) opt_value = undefined;

        try {
            ga('send', 'event', category, action, opt_label, opt_value,
                {
                    nonInteraction: opt_noninteraction,
                    'dimension1': 'New Website Hit',
                    'dimension2': 'New Website Session',
                    'dimension3': 'New Website User'

                });

        } catch (e) {
            // console.log(e);
        }
    }

    trackClickItem(item, category, location) {
        var name = item.text().trim();
        var dest = item.attr('href').trim();
        this.gaTrackEvent(category, "Click", "Current URL: " + location + ", Navigation item: " + name + ", Link: " + dest, undefined, true);
    }

    globalItems() {

        var _this = this;

        $(".site-header__top-menu").on("click", ".site-header__top-menu__item:not(.js-toggle-site-header__locations) ", function (e) {
            _this.trackClickItem( $(this).find('a'), "Global Navigation", window.location.href);
        });
    }

    locationItems() {

        var _this = this;

        $(".site-header__locations .site-header__locations__list").on("click", "li", function (e) {
            _this.trackClickItem( $(this).children('a'), "Location Navigation", window.location.href);
        });
    }

    primaryItems() {
        
        var _this = this;

        $(".site-header__nav").on("click", ".site-nav__list__item", function (e) {
            _this.trackClickItem( $(this).children('a'), "Primary Navigation", window.location.href);
        });

        //Mobile
        $(".site-nav-mobile").on("click", ".site-nav-mobile__list__item", function (e) {
            _this.trackClickItem( $(this).children('a'), "Primary Navigation", window.location.href);
        });
    }

    secondaryItems() {		

        var _this = this;

        $(".site-nav__l1 .site-nav__l2").on("click", ".site-nav__column__item", function (e) {
            _this.trackClickItem( $(this).children('a'), "Secondary Navigation", window.location.href);
        });

        //Mobile
        $(".site-nav-mobile__l1 .site-nav-mobile__l2").on("click", ".site-nav-mobile__list__item", function (e) {
            _this.trackClickItem( $(this).children('a'), "Secondary Navigation", window.location.href);
        });
    }

    footerItems() {		

        var _this = this;

        $(".footerlinks").on("click", ".footerlinks__item", function (e) {
            _this.trackClickItem( $(this).children('a'), "Footer Navigation", window.location.href);
        });
    }

    miscItems() {		

        var _this = this;

        // homepage hero button
        //$(".hero-home__text-inner").on("click", "p", function (e) {
            //_this.trackClickItem( $(this).children('a'), "Button", window.location.href);
        //});

        // enquire online button
        $('*[data-enquiry-url-check]').on("click", function (e) {
            _this.trackClickItem( $(this), "Enquiry CTA", window.location.href);
        });

        //Enquiry form CTA buttons
        $('.call-to-action__link').on('click', function () {
            if ($(this).hasClass('call-to-action__link--enquiry')) {
                _this.trackClickItem( $(this), "Enquiry CTA", window.location.href);
            }
            if ($(this).hasClass('call-to-action__link--callback')) {
                _this.trackClickItem( $(this), "Call back CTA", window.location.href);
            }
        });	

        //Mobile enquiry form CTA phone numbers
        //$('.call-to-action--mobile-nav').on('click', '.call-to-action__tel', function () {
        //    _this.trackClickItem( $(this), "Telephone number CTA", window.location.href);
        //});	

    }
    

    allItems() {
        //this.globalItems();
        this.locationItems();
       // this.primaryItems();	    
        this.secondaryItems();
        //this.footerItems();
        this.miscItems();
    }


    init() {
       
    }
}






